import styled from 'styled-components';

const StatusPill = styled.p`
    display: flex;
    font-weight: 500;
    color: #fff;
    padding: 9px 39px;
    text-align: center;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    text-transform: capitalize;
    margin: 5px;
    border-radius: 34.5px;
    width: 107px;
    height: 30px;
    background-color: #DFDFDF;
    &.high {
      background-color: #E16408;
    }
    &.low {
      background-color: #00ABAB;
    }
      &.unknown {
        background-color: #263238;
      }
`;

export {StatusPill}